// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__1Oydw","row":"ProcedureTreatmentSummary_row__2SGrB"};